export default {
  getWebhooks(state) {
    return state.webhooks;
  },
  getWebhooksTypes(state) {
    return state.webhooksTypes;
  },
};
